export default __webpack_public_path__ + "static/media/003-kangaroo.dd1c0e07.svg";